import { render } from "./TabBar.vue?vue&type=template&id=e79e5174&scoped=true&ts=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"

import "./TabBar.vue?vue&type=style&index=0&id=e79e5174&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79e5174"]])

export default __exports__